import { mapActions } from 'vuex';

export default {
  data: () => ({
    inProgress: false,
  }),
  methods: {
    ...mapActions('userNotifications', ['removeUserNotifications']),
    clickSubscriptionsBtn(notificationKey) {
      this.dismiss(notificationKey).finally(() => {
        this.$router.push('/subscription');
      });
    },
    dismiss(notificationKey) {
      this.inProgress = true;
      return this.removeUserNotifications(notificationKey).finally(() => {
        this.inProgress = false;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/userNotifications/userNotitficationsMixin.js